import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=d1c02ef0&scoped=true&lang=pug&"
import script from "./Notifications.vue?vue&type=script&lang=js&"
export * from "./Notifications.vue?vue&type=script&lang=js&"
import style0 from "./Notifications.vue?vue&type=style&index=0&id=d1c02ef0&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c02ef0",
  null
  
)

export default component.exports